/* eslint-disable no-console */

// import 'core-js/stable';
// import 'regenerator-runtime/runtime';

import { MK } from 'MK'

export { MK }

window.MK = new MK()

// try {
//   console.log('DEBUG (polyfills.initialize) Initializing browser detection.')
//   require('polyfills/browserDetection').browserDetection.initialize()
// } catch (error) {
//   console.log('!!! ERROR (polyfills.initialize) Error encountered during browser detection bundle initialization.')
//   console.log(error)
//   MK.captureException(error)
// }

// Initialize polyfills
// require('polyfills').polyfills.initialize()
import( /* webpackMode: "eager", webpackChunkName: "polyfills" */ 'polyfills')
  .then(bundle => bundle.polyfills.initialize())
  .catch(error => MK.capturePromiseRejection && MK.capturePromiseRejection(error))

// Initialize other modules
import( /* webpackMode: "eager", webpackChunkName: "bootstrap" */ 'eddiebauer.com/bootstrap')
  .then(bundle => bundle.bootstrap.initialize())
  .catch(error => MK.capturePromiseRejection && MK.capturePromiseRejection(error))


